export const initState = {
	render: 'board', // chart, board
	$list: [],
	_list: 'init',

	selectBox: {
		$currencyList: [],
		_currencyList: 'init',

		symbol: null, // IQD, IRR, USD, ...
		period: null, // D: day, W: week, M: mount, Y: year
		fromDate: null, // 14001212
		toDate: null, // 14001212

		price: 'buy', // buy, sell
	},
};

export default initState;
